import { MonsterSpriteNames } from "../monster/MonsterSpriteNames";
import DawnLikeSprite from "./DawnLikeSprite";
import MonsterAnimationFrameSpritesheet from "./MonsterAnimationFrameSpritesheet";
import SpriteAnimationManager from "./SpriteAnimationManager";

export default class MonsterSpritesheet {
    /**
     * @param {string} fileName0 
     * @param {string} fileName1 
     * @param {number} spriteSize 
     * @param {SpriteAnimationManager} spriteAnimationManager
     */
    constructor(fileName0, fileName1, spriteSize, spriteAnimationManager) {
        /**
         * @constant
         * @type {SpriteAnimationManager}
         */
        this.spriteAnimationManager = spriteAnimationManager;

        /**
         * @constant
         * @type {number}
         */
        this.spriteSize = spriteSize;
        
        /**
         * The mapping of sprites by name.
         * @private
         * @type {{}}
         */
        this.spriteMap = {};

        /**
         * @constant
         * @type {MonsterAnimationFrameSpritesheet}
         */
        this.animationFrameSpritesheet0 = new MonsterAnimationFrameSpritesheet(fileName0, spriteSize, this);
        /**
         * @constant
         * @type {MonsterAnimationFrameSpritesheet}
         */
        this.animationFrameSpritesheet1 = new MonsterAnimationFrameSpritesheet(fileName1, spriteSize, this);

    }

    onSpritesheetLoaded() {
        if (this.animationFrameSpritesheet0.loaded && this.animationFrameSpritesheet1.loaded) {
            this.populateSpriteMap();
        }
    }
    
    /**
     * @returns {boolean}
     */
    isLoaded() {
        return this.animationFrameSpritesheet0.loaded && this.animationFrameSpritesheet1.loaded;
    }

    /**
     * @param {string} name
     * @returns {Sprite}
     */
    getSprite(name) {
        return this.spriteMap[name];
    }

    /**
     * @inheritdoc
     * @override
     */
    populateSpriteMap() {

        let row = 0;

        /////////////////////////////////////////
        // ROW 0
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.AQUATIC_SNAKE_TAN_1,
            MonsterSpriteNames.AQUATIC_SNAKE_TAN_2,
            MonsterSpriteNames.AQUATIC_SNAKE_BLACK_1,
            MonsterSpriteNames.AQUATIC_SNAKE_BLACK_2,
            MonsterSpriteNames.AQUATIC_MONSTER,
            MonsterSpriteNames.AVIAN_BAT_BROWN_SMALL,
            MonsterSpriteNames.AVIAN_BAT_BROWN_LARGE,
            MonsterSpriteNames.AVIAN_BAT_BLACK_LARGE,

        ]);
        row++;

        /////////////////////////////////////////
        // ROW 1
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.AVIAN_BAT_BROWN_SMALL2,
            MonsterSpriteNames.AVIAN_BAT_BROWN_LARGE2,
            MonsterSpriteNames.DEMON_REPTILIAN_GREEN,
            MonsterSpriteNames.DEMON_REPTILIAN_WINGED,
            MonsterSpriteNames.DEMON_BROWN,
            MonsterSpriteNames.DEMON_BLOB,
            MonsterSpriteNames.DEMON_BLUE,
            MonsterSpriteNames.DEMON_BLUE_WINGED,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 2
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.DEMON_RED_GLOWING,
            MonsterSpriteNames.DEMON_RED_WINGED_1,
            MonsterSpriteNames.DEMON_RED_WINGED_2,
            MonsterSpriteNames.DEMON_RED_DARK_LARGE,
            MonsterSpriteNames.DEMON_RED_LARGE,
            MonsterSpriteNames.DEMON_RED_PALE_LARGE,
            MonsterSpriteNames.DEMON_BLUE_LARGE,
            MonsterSpriteNames.DEMON_BLUE_RED_LARGE,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 3
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.DEMON_GREEN_EYE_STOCKS,
            MonsterSpriteNames.DEMON_GREEN_EVIL_WINGED,
            MonsterSpriteNames.DEMON_RED_DARK_WHIP,
            MonsterSpriteNames.DEMON_RED_TINY_JUMPING,
            MonsterSpriteNames.DEMON_RED_SMALL_JUMPING,
            MonsterSpriteNames.DEMON_ARMORED,
            MonsterSpriteNames.DEMON_HELMET_HORNED,
            MonsterSpriteNames.DEMON_RED_FANGED,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 4
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.DEMON_GREEN_FROG_LIKE,
            MonsterSpriteNames.ELEMENTAL_WARRIOR,
            MonsterSpriteNames.ELEMENTAL_SQUID,
            MonsterSpriteNames.ELEMENTAL_GOLEM,
            MonsterSpriteNames.ELEMENTAL_GOLEM_DARK,
            MonsterSpriteNames.ELEMENTAL_GOLEM_RUSTY,
            MonsterSpriteNames.ELEMENTAL_BLOODY,
            MonsterSpriteNames.ELEMENTAL_STONE,
        ]);
        row++;


        /////////////////////////////////////////
        // ROW 5
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.ELEMENTAL_SWIRL_ORANGE,
            MonsterSpriteNames.ELEMENTAL_SWIRL_YELLOW,
            MonsterSpriteNames.ELEMENTAL_SWIRL_BLUE_DARK,
            MonsterSpriteNames.ELEMENTAL_SWIRL_BLUE_LIGHT,
            MonsterSpriteNames.ELEMENTAL_SWIRL_RED,
            MonsterSpriteNames.ELEMENTAL_CREEPY_RED,
            MonsterSpriteNames.ELEMENTAL_CREEPY_BROWN,
            MonsterSpriteNames.ELEMENTAL_CREEPY_LIGHT_BLUE,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 6
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.ELEMENTAL_BALL_GREEN,
            MonsterSpriteNames.ELEMENTAL_BALL_BLUE,
            MonsterSpriteNames.ELEMENTAL_BALL_RED,
            MonsterSpriteNames.ELEMENTAL_BALL_BLACK,
            MonsterSpriteNames.ELEMENTAL_EYE_WHITE,
            MonsterSpriteNames.ELEMENTAL_EYE_RED,
            MonsterSpriteNames.ELEMENTAL_EYE_BEHOLDER,
            MonsterSpriteNames.HUMANOID_210_SASQUATCH,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 7
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.HUMANOID_000,
            MonsterSpriteNames.HUMANOID_001,
            MonsterSpriteNames.HUMANOID_002,
            MonsterSpriteNames.HUMANOID_003,
            MonsterSpriteNames.HUMANOID_004,
            MonsterSpriteNames.HUMANOID_005,
            MonsterSpriteNames.HUMANOID_006,
            MonsterSpriteNames.HUMANOID_007,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 8
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.HUMANOID_010_MINOTAUR,
            MonsterSpriteNames.HUMANOID_011_CYCLOPS,
            MonsterSpriteNames.HUMANOID_040_WALRUS_MAN,
            MonsterSpriteNames.HUMANOID_041_WALRUS_MAN,
            MonsterSpriteNames.HUMANOID_042_WALRUS_MAN,
            MonsterSpriteNames.HUMANOID_043_WALRUS_MAN,
            MonsterSpriteNames.HUMANOID_044_WALRUS_MAN,
            MonsterSpriteNames.HUMANOID_045_WALRUS_MAN,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 9
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.HUMANOID_046_WALRUS_MAN,
            MonsterSpriteNames.HUMANOID_070,
            MonsterSpriteNames.HUMANOID_071,
            MonsterSpriteNames.HUMANOID_072,
            MonsterSpriteNames.HUMANOID_073,
            MonsterSpriteNames.HUMANOID_170_STONE_SERPENT,
            MonsterSpriteNames.HUMANOID_171_STONE_SERPENT,
            MonsterSpriteNames.MISC_ANIMAL_70,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 10
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.HUMANOID_190_DEMON_BASHER,
            MonsterSpriteNames.HUMANOID_191_DEMON_BASHER,
            MonsterSpriteNames.HUMANOID_200_SQUID_DEMON,
            MonsterSpriteNames.HUMANOID_201_SQUID_DEMON,
            MonsterSpriteNames.MISC_ANIMAL_03_OWL,
            MonsterSpriteNames.MISC_ANIMAL_04,
            MonsterSpriteNames.MISC_ANIMAL_05,
            MonsterSpriteNames.MISC_ANIMAL_06,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 11
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.MISC_ANIMAL_11,
            MonsterSpriteNames.MISC_ANIMAL_12,
            MonsterSpriteNames.MISC_ANIMAL_50,
            MonsterSpriteNames.MISC_ANIMAL_51,
            MonsterSpriteNames.MISC_ANIMAL_52,
            MonsterSpriteNames.MISC_ANIMAL_53,
            MonsterSpriteNames.PEST_LADYBUG_100,
            MonsterSpriteNames.PEST_LADYBUG_101,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 12
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.PEST_TINY_00,
            MonsterSpriteNames.PEST_TINY_01,
            MonsterSpriteNames.PEST_TINY_02,
            MonsterSpriteNames.PEST_TINY_03,
            MonsterSpriteNames.PEST_TINY_04,
            MonsterSpriteNames.PEST_TINY_05,
            MonsterSpriteNames.PEST_TINY_WORM_1,
            MonsterSpriteNames.PEST_TINY_WORM_2,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 13
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.PEST_ANT_10,
            MonsterSpriteNames.PEST_INSECT_11,
            MonsterSpriteNames.PEST_INSECT_12,
            MonsterSpriteNames.PEST_INSECT_13,
            MonsterSpriteNames.PEST_INSECT_14,
            MonsterSpriteNames.PEST_SPIDER_20,
            MonsterSpriteNames.PEST_SPIDER_21,
            MonsterSpriteNames.PEST_SPIDER_22,
        ]);
        row++;


        /////////////////////////////////////////
        // ROW 14
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.PEST_SCORPION_23,
            MonsterSpriteNames.PEST_SCORPION_24,
            MonsterSpriteNames.PEST_SCORPION_25,
            MonsterSpriteNames.PEST_WORM_30,
            MonsterSpriteNames.PEST_WORM_31,
            MonsterSpriteNames.PEST_BALL,
            MonsterSpriteNames.PEST_WORM_33,
            MonsterSpriteNames.PEST_WORM_34,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 15
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.PEST_GIANT_ANT_40,
            MonsterSpriteNames.PEST_GIANT_ANT_41,
            MonsterSpriteNames.PEST_GIANT_ANT_42,
            MonsterSpriteNames.PEST_GIANT_ANT_43,
            MonsterSpriteNames.PEST_SLUG_70,
            MonsterSpriteNames.PEST_SLUG_71,
            MonsterSpriteNames.PEST_SNAIL_72,
            MonsterSpriteNames.PEST_SNAIL_73,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 16
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.PEST_INSECT_60,
            MonsterSpriteNames.PEST_INSECT_61,
            MonsterSpriteNames.PEST_INSECT_80,
            MonsterSpriteNames.PEST_INSECT_81,
            MonsterSpriteNames.MINOR_DEVIL,
            MonsterSpriteNames.MINOR_DEVIL_WARRIOR,
        ]);
        row++;

        // BLANK
        // BLANK

        /////////////////////////////////////////
        // ROW 17
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.ORC1,
            MonsterSpriteNames.ORC_WARRIOR,
            MonsterSpriteNames.ORC_FIGHTER,
            MonsterSpriteNames.ORC_KARATE,
            MonsterSpriteNames.ORC_PIRATE,
            MonsterSpriteNames.ORC2,
            MonsterSpriteNames.ORC3,
            MonsterSpriteNames.ORC4,
        ]);
        row++;


        /////////////////////////////////////////
        // ROW 18
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.DRAGON_MAN_BASIC,
            MonsterSpriteNames.DRAGON_MAN_EXPLORER,
            MonsterSpriteNames.DRAGON_MAN_FIGHTER,
            MonsterSpriteNames.DRAGON_MAN_RUFFIAN,
            MonsterSpriteNames.DRAGON_MAN_RANGER,
            MonsterSpriteNames.DRAGON_MAN_TERRIBLE,
            MonsterSpriteNames.DRAGON_MAN_MERCILESS,
            MonsterSpriteNames.DRAGON_MAN_FIERY,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 19
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.QUADRUPED_000,
            MonsterSpriteNames.QUADRUPED_001,
            MonsterSpriteNames.QUADRUPED_002,
            MonsterSpriteNames.QUADRUPED_003,
            MonsterSpriteNames.QUADRUPED_004,
            MonsterSpriteNames.QUADRUPED_005,
            MonsterSpriteNames.QUADRUPED_006,
            MonsterSpriteNames.QUADRUPED_007,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 20
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.RODENT_10_RAT_SMALL,
            MonsterSpriteNames.RODENT_11_RAT,
            MonsterSpriteNames.RODENT_12_RAT_LARGE_BROWN,
            MonsterSpriteNames.RODENT_13_RAT_LARGE_GREY,
            MonsterSpriteNames.RODENT_20_RAT_POISONOUS,
            MonsterSpriteNames.RODENT_21_RAT_ZOMBIE,
            MonsterSpriteNames.RODENT_22_MOLE,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 21
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.SLIME_BLUE_00,
            MonsterSpriteNames.SLIME_BROWN_01,
            MonsterSpriteNames.SLIME_WHITE_02,
            MonsterSpriteNames.SLIME_GREEN_03,
            MonsterSpriteNames.SLIME_PINK_04,
            MonsterSpriteNames.SLIME_PURPLE_05,
            MonsterSpriteNames.SLIME_MUCUS_GREEN_40,
            MonsterSpriteNames.SLIME_MUCUS_BLUE_41,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 22
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.SLIME_CORRODED_20,
            MonsterSpriteNames.SLIME_SEEING_21,
            MonsterSpriteNames.SLIME_ORANGE_22,
            MonsterSpriteNames.SLIME_MINI_BLUE_30,
            MonsterSpriteNames.SLIME_MINI_31,
            MonsterSpriteNames.SLIME_MINI_ORANGE_32,
            MonsterSpriteNames.UNDEAD_WRAITH_0600,
            MonsterSpriteNames.UNDEAD_WRAITH_0601,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 23
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.UNDEAD_GOBLIN0,
            MonsterSpriteNames.UNDEAD_GOBLIN1,
            MonsterSpriteNames.UNDEAD_GOBLIN2,
            MonsterSpriteNames.UNDEAD_GOBLIN3,
            MonsterSpriteNames.UNDEAD_GOBLIN4,
            MonsterSpriteNames.UNDEAD_GOBLIN5,
            MonsterSpriteNames.UNDEAD_GOBLIN6,
            MonsterSpriteNames.UNDEAD_GOBLIN7
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 24
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.UNDEAD_KOBOLD_SKELETON_0200,
            MonsterSpriteNames.UNDEAD_KOBOLD_SKELETON_0201,
            MonsterSpriteNames.UNDEAD_KOBOLD_SKELETON_0202,
            MonsterSpriteNames.UNDEAD_KOBOLD_SKELETON_0203,
            MonsterSpriteNames.UNDEAD_KOBOLD4,
            MonsterSpriteNames.UNDEAD_KOBOLD5,
            MonsterSpriteNames.UNDEAD_KOBOLD_KING_0206,
            MonsterSpriteNames.UNDEAD_KOBOLD_ANCIENT_EVIL7,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 25
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.UNDEAD_GHOST_0400,
            MonsterSpriteNames.UNDEAD_GHOST_0401,
            MonsterSpriteNames.UNDEAD_GHOST_0402,
            MonsterSpriteNames.UNDEAD_GHOST_0403,
            MonsterSpriteNames.UNDEAD_REAPER_0500,
            MonsterSpriteNames.UNDEAD_REAPER_0501,
            MonsterSpriteNames.UNDEAD_REAPER_0502,
            MonsterSpriteNames.UNDEAD_DARKNESS_0801,
        ]);
        row++;

        /////////////////////////////////////////
        // ROW 26
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.REPTILE_FLYING_SERPENT_SMALL_002,
            MonsterSpriteNames.REPTILE_FLYING_SERPENT_003,
        ]);
        row++;


        /////////////////////////////////////////
        // ROW 27
        /////////////////////////////////////////

        this.parseRow(row, [
            MonsterSpriteNames.REPTILE_BROWN_SERPENT_SMALL_040,
            MonsterSpriteNames.REPTILE_BROWN_SERPENT_041,
            MonsterSpriteNames.REPTILE_BROWN_SERPENT_LARGE_042,
            MonsterSpriteNames.REPTILE_BLACK_SERPENT_043,
            MonsterSpriteNames.REPTILE_BLACK_SERPENT_LARGE_044,
            MonsterSpriteNames.REPTILE_BLACK_SERPENT_POISONOUS_045,
            MonsterSpriteNames.REPTILE_GREEN_SNAKE_SMALL_046,
            MonsterSpriteNames.REPTILE_GREEN_SNAKE_047,
        ]);
        row++;

        /////////////////////////////////////
        // Mark the spritesheet as loaded.
        /////////////////////////////////////

        this.loaded = true;
    }

    /**
     * @private
     * @param {number} row 
     * @param {Array.<string>} names
     */
    parseRow(row, names) {
        const step = this.spriteSize + 1; // There is a 1px buffer between the sprites, only on the bottom and right edges.

        const y = row * step;
        let x = 0;

        // Iterate over the fixture color configs
        for (let i = 0; i < + names.length; i++) {
            this.spriteMap[names[i]] = new DawnLikeSprite(this.spriteAnimationManager, this.animationFrameSpritesheet0, this.animationFrameSpritesheet1, x, y);
            x += step;
        }
    }

}